import React, { FC, useCallback, useEffect, useState } from 'react'
import { IntlProvider } from 'react-intl'
import { ThemeProvider } from 'styled-components'

import { theme, Modal } from '@elamajs/ui-kit'

import * as Styled from './PartnersModalSuccess.styled'

const PartnersModalSuccess: FC = () => {
  const [isOpened, setIsOpened] = useState(false)

  useEffect((): (() => void) => {
    const handleOpen = (): void => {
      setIsOpened(true)
    }

    document.addEventListener('partners-form-new:open', handleOpen)

    return (): void => {
      document.removeEventListener('partners-form-new:open', handleOpen)
    }
  }, [])

  const handleClose = useCallback(() => {
    setIsOpened(false)
  }, [])

  return (
    <Styled.Modal as={Modal} isOpened={isOpened} onRequestClose={handleClose}>
      <Modal.Header>
        <Styled.Header>Спасибо за&nbsp;заявку!</Styled.Header>
      </Modal.Header>
      <Modal.Content>
        <Styled.Text>
          Мы&nbsp;свяжемся с&nbsp;вами в&nbsp;течение одного рабочего дня. Если вам нужно
          проконсультироваться по&nbsp;началу работы с&nbsp;eLama прямо сейчас, звоните:
          <Styled.Phone>8 (800) 500&ndash;31&ndash;90 (доб.&nbsp;8)</Styled.Phone>
        </Styled.Text>
      </Modal.Content>
    </Styled.Modal>
  )
}

const withProviders = (Component: FC): FC => {
  const NewComponent: FC = () => {
    return (
      <ThemeProvider theme={theme}>
        <IntlProvider locale="ru">
          <Component />
        </IntlProvider>
      </ThemeProvider>
    )
  }

  return NewComponent
}

export default withProviders(PartnersModalSuccess)
